import React from 'react'
import * as Icons from 'ui/icons'
import { SquareButton } from 'ui'

function DeleteButton (props) {
  return (
    <SquareButton color='btn-red' {...props}>
      <Icons.Trash className='w-4 h-4' />
    </SquareButton>
  )
}

export default DeleteButton
